module.exports = __webpack_public_path__ + "static/media/01_enbrain_info.c7d67be3.png";